import React from "react";
import { useTranslation } from "react-i18next";

import Tooltip from "components/Tooltip";

import styles from "./ProviderGeoRestrictionsCell.module.scss";

interface Props {
  codes?: string[] | null;
}

const VISIBLE_CODES = 3;

const ProviderGeoRestrictionsCell: React.FC<Props> = ({ codes }) => {
  const { t } = useTranslation();
  const countryCodes = (codes || [])
    .map((code) => String(code || "").trim().toUpperCase())
    .filter(Boolean);

  if (countryCodes.length === 0) {
    return <span>{t("noRestrictions")}</span>;
  }

  const visibleCodes = countryCodes.slice(0, VISIBLE_CODES);
  const hiddenCodes = countryCodes.slice(VISIBLE_CODES);
  const hiddenCount = hiddenCodes.length;

  return (
    <div className={styles.restrictions}>
      {visibleCodes.map((code) => (
        <span className={styles.code} key={code}>
          {code}
        </span>
      ))}
      {hiddenCount > 0 && (
        <Tooltip text={hiddenCodes.join(", ")} asChild>
          <button
            className={styles.more}
            type="button"
            aria-label={t("geoRestrictionsMore", { count: hiddenCount })}
            onClick={(event) => event.stopPropagation()}
          >
            +{hiddenCount}
          </button>
        </Tooltip>
      )}
    </div>
  );
};

export default ProviderGeoRestrictionsCell;
